import React, { useState } from "react";
import Layout from "../components/common/Layout";
import HeroSection from "../components/common/HeroSection";
import FormCon from "../components/Form/FormCon";
import FieldArray from "../components/Form/FieldArray";
import LoadBtn from "../components/Form/LoadBtn";
import { getSEOData } from "../utils/seo";
import JobList from "../components/jobs/JobList";

function Contact() {
  const seoData = getSEOData("contact-luxury-apartments-chennai");

  const [selectedJobId, setSelectedJobId] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const handleJobApply = (jobId) => {
    setSelectedJobId(jobId);
    setShowModal(true);
  };

  return (
    <Layout seoData={seoData}>
      <HeroSection title="Contact Us" />

      <section className="residence-section pb-5">
        <div className="container">

          {/* ================= CONTACT SECTION ================= */}
          <div className="row">

            {/* LEFT COLUMN */}
            <div className="col-md-8">

              {/* Address */}
              <div className="pb-4">
                <h5 className="residence-section-title">Address</h5>

                <p>
                  Baashyaam Constructions Pvt. Ltd.<br />
                  4th Floor, No.87 G.N. Chetty Road,<br />
                  T.Nagar, Chennai, 600 017.
                </p>

                <iframe
                  title="google-maps"
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3886.8428696551146!2d80.23938361482276!3d13.045671890807329!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a526650dc5e5465%3A0x687f50d8c8c2a712!2sBaashyaam%20Constructions!5e0!3m2!1sen!2sin!4v1580453063144!5m2!1sen!2sin"
                  height={350}
                  frameBorder={0}
                  style={{ border: 0, width: "100%" }}
                  allowFullScreen
                />
              </div>

              {/* Contact Details */}
              <div className="pb-4">
                <h5 className="residence-section-title">Contact Details</h5>

                <div className="mb-2">
                  <a
                    className="d-flex align-items-center link-color"
                    href="tel:+919840477777"
                  >
                    <span className="mr-3">📞</span>
                    <span>+91 9840477777</span>
                  </a>
                </div>

                <div>
                  <a
                    className="d-flex align-items-center link-color"
                    href="mailto:enquiry@bashyamgroup.com"
                  >
                    <span className="mr-3">✉</span>
                    <span>enquiry@bashyamgroup.com</span>
                  </a>
                </div>
              </div>

            </div>

            {/* RIGHT COLUMN */}
            <div className="col-md-4">

              <div className="card shadow-sm">
                <div className="card-body">

                  <h4 className="mb-3 text-center font-weight-bold">
                    Get In Touch
                  </h4>

                  <FormCon
                    resetOnSuccess
                    form={{
                      inputs: {
                        candidate_name: {
                          name: "candidate_name",
                          type: "text",
                          placeholder: "Enter your name",
                        },
                        email_id: {
                          name: "email_id",
                          type: "email",
                          placeholder: "Enter your email",
                        },
                        mobile_number: {
                          name: "mobile_number",
                          type: "tel",
                          placeholder: "Enter your phone number",
                        },
                        requisition: {
                          name: "requisition",
                          type: "hidden",
                        },
                      },
                      allIds: [
                        "candidate_name",
                        "email_id",
                        "mobile_number",
                        "requisition",
                      ],
                    }}
                    config={{
                      url: "https://bemss.in/api/emp/website-enquiry/",
                      method: "POST",
                      transformData: (values) => values,
                    }}
                    renderForm={({ fetching }) => (
                      <>
                        <FieldArray />
                        <div className="form-group">
                          <LoadBtn
                            fetching={fetching}
                            className="btn btn-block btn-logo-color"
                          >
                            Enquiry Now
                          </LoadBtn>
                        </div>
                      </>
                    )}
                  />

                </div>
              </div>

            </div>

          </div>

          {/* ================= JOB LIST SECTION FULL WIDTH ================= */}

          <div className="row mt-5">

            <div className="col-12">

              <div className="job-section-wrapper">

                <h3 className="text-center mb-3">
                  Current Openings
                </h3>

                <p className="text-center mb-4">
                  Explore exciting career opportunities with us.
                </p>

                <JobList onApply={handleJobApply} />

              </div>

            </div>

          </div>

        </div>
      </section>

      {/* ================= MODAL ================= */}

      {showModal && (
        <div className="modal-overlay">
          <div className="modal-content card shadow">

            <div className="card-body">

              <div className="d-flex justify-content-between mb-3">
                <h4 className="font-weight-bold">Apply for Job</h4>

                <button
                  onClick={() => setShowModal(false)}
                  className="btn btn-sm btn-light"
                >
                  ✖
                </button>
              </div>

              <FormCon
                resetOnSuccess
                form={{
                  inputs: {
                    candidate_name: {
                      name: "candidate_name",
                      type: "text",
                      placeholder: "Enter your name",
                    },
                    email_id: {
                      name: "email_id",
                      type: "email",
                      placeholder: "Enter your email",
                    },
                    mobile_number: {
                      name: "mobile_number",
                      type: "tel",
                      placeholder: "Enter your phone number",
                    },
                    requisition: {
                      name: "requisition",
                      type: "hidden",
                    },
                  },
                  allIds: [
                    "candidate_name",
                    "email_id",
                    "mobile_number",
                    "requisition",
                  ],
                  values: {
                    requisition: selectedJobId,
                  },
                }}
                config={{
                  url: "https://bemss.in/api/emp/website-enquiry/",
                  method: "POST",
                  transformData: (values) => values,
                }}
                renderForm={({ fetching }) => (
                  <>
                    <FieldArray />
                    <div className="form-group">
                      <LoadBtn
                        fetching={fetching}
                        className="btn btn-block btn-logo-color"
                      >
                        Submit Application
                      </LoadBtn>
                    </div>
                  </>
                )}
              />

            </div>

          </div>
        </div>
      )}

    </Layout>
  );
}

export default Contact;